export default "__VITE_ASSET__06562ca3__"